export const COMMAND_CONTAINER_TEST_ID = 'command-palette.ui.modal.body.command-container';
export const COMMAND_INNER_CONTAINER_TEST_ID =
	'command-palette.common.ui.command-palette-row-view.inner-container';
export const LEFT_ICON_TEST_ID = 'command-palette.ui.modal.body.command-left-icon-container';
export const MODE_TEST_ID = 'command-palette.ui.modal.body.command-mode';
export const COMMAND_ICON_CONTAINER_TEST_ID =
	'command-palette.ui.modal.body.command-icon-container';
